@use '../../../../app/styles/common/mixins';

.list {
  display: flex;
  flex-direction: column;

  // Figma spaces the 19px rows 29px apart; there is no 10px spacing token.
  gap: 10px;
}

.showMore {
  margin-top: var(--spasing12);

  @include mixins.laptop {
    margin-top: var(--spasing16);
  }
}
